/** Tailwind class map for onboarding chrome, using eAteliers pink (scoped on .eateliers-brand). */
export const ONBOARDING_BRAND = {
  scope: "eateliers-brand",
  page: "eateliers-brand onboarding-shell",
  content: "relative z-10 w-full",
  progressActive: "onboarding-progress-active",
  progressIdle: "onboarding-progress-idle",
  underline: "h-1 w-32 bg-gradient-to-r from-as-pink-200 to-as-pink-400 rounded-full mx-auto",
  selectedSurface: "border-as-pink-400 bg-white/70 dark:bg-white/10 shadow-sm",
  idleSurface: "border-as-pink-200/80 bg-white/40 dark:bg-white/5 hover:border-as-pink-300 hover:bg-white/60",
  accentControl: "accent-as-pink-300 border-gray-300 focus:ring-as-pink-200",
  optionLabelHover: "group-hover:text-as-pink-500",
  stepChip: "flex-shrink-0 w-8 h-8 rounded-full bg-as-pink-200 flex items-center justify-center",
  stepChipText: "text-as-pink-500 font-semibold text-sm",
  recommendedCard: "border-as-pink-300 ring-2 ring-as-pink-200 bg-white/70 dark:bg-white/10",
  recommendedBadge:
    "absolute -top-3 left-1/2 -translate-x-1/2 bg-as-pink-300 text-white text-xs font-semibold px-3 py-1 rounded-full",
} as const;

export const onboardingChoiceSurface = (selected: boolean): string =>
  selected ? ONBOARDING_BRAND.selectedSurface : ONBOARDING_BRAND.idleSurface;
